import { getURLBasedOnLocation } from '@/helpers/utils';

export const queryPromotions = () =>
  fetch(`https://assets.${getURLBasedOnLocation()}/promotions/state.json`)
    .then((response) => response.json())
    .then((data) => data);
